<template v-on:keyup.enter="CambiarPreguntaSiguiente($event)">
  <div>
    <!--<div slot="title">
      <h2>Cuestionario</h2>
    </div>-->
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 d-flex justify-content-around"><h4 class="label-black" v-if="Cuestionario != null">{{Cuestionario.FormatoCuestionario}}: {{Cuestionario.Evaluado.NombreCompleto}}</h4></div>
        </div>
        <div class="row cuestionario-area" style="margin-top:20px;">
          <div class="col-1 columna-flecha-navegacion centrado-vertical arrow-custom" @click="CambiarPreguntaAnterior($event)">
            <i class="fas fa-arrow-alt-circle-left"></i>
          </div>
          <div class="col-10">
            <div id="carruselCuestionario" class="carousel">
              <ol class="carousel-indicators label-black">
                <li class="label-black" data-target="#carruselCuestionario" v-bind:data-slide-to="index"
                    v-bind:id="index"
                    v-bind:key="`li-${index}`"
                    v-bind:class="{active: index == 0}"
                    v-for="(Pregunta,index) in Preguntas"
                    @click="slideChange($event,index,1)"><i class="fas fa-check"></i></li>

                

              </ol>
              <div class="carousel-inner">
                <div v-for="(Pregunta,index) in Preguntas" class="carousel-item " v-bind:class="{active: index == 0}" v-bind:key="`div-${index}`">
                  <form>
                    <div class="row">
                      <div class="col-1"></div>
                      <div class="col-10">
                        <div class="form-group text-center label-black">
                          <span class="pregunta">{{Pregunta.Pregunta}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row respuesta centrado-vertical">
                      <div class="col-12 form-group text-left label-black">
                        <input v-bind:id="idGenerator(index,1)"
                               @click="MarcarRespuesta(1,index)"
                               name="respuesta-radio"
                               type="radio"
                               data-id-respuesta="1" />
                        <span for="input-respuesta1" @click="SeleccionarRespuesta(index,1)">{{Pregunta.Respuesta1}}</span>
                      </div>
                    </div>
                    <div class="row respuesta centrado-vertical">
                      <div class="col-12 form-group text-left label-black">
                        <input v-bind:id="idGenerator(index,2)"
                               @click="MarcarRespuesta(2,index)"
                               name="respuesta-radio"
                               type="radio"
                               data-id-respuesta="2" />
                        <span for="input-respuesta2" @click="SeleccionarRespuesta(index,2)">{{Pregunta.Respuesta2}}</span>
                      </div>
                    </div>
                    <div class="row respuesta centrado-vertical">
                      <div class="col-12 form-group text-left label-black">
                        <input v-bind:id="idGenerator(index,3)"
                               @click="MarcarRespuesta(3,index)"
                               name="respuesta-radio"
                               type="radio"
                               data-id-respuesta="3" />
                        <span for="input-respuesta3"  @click="SeleccionarRespuesta(index,3)">{{Pregunta.Respuesta3}}</span>
                      </div>
                    </div>
                    <div class="row respuesta centrado-vertical">
                      <div class="col-12 form-group text-left label-black">
                        <input v-bind:id="idGenerator(index,4)"
                               @click="MarcarRespuesta(4,index)"
                               name="respuesta-radio"
                               type="radio"
                               data-id-respuesta="4" />
                        <span for="input-respuesta4"  @click="SeleccionarRespuesta(index,4)">{{Pregunta.Respuesta4}}</span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1 columna-flecha-navegacion centrado-vertical" @click="CambiarPreguntaSiguiente($event)">
            <i id="flechaSiguiente" class="fas fa-arrow-alt-circle-right arrow-custom"></i>
          </div>
        </div>
        <hr />
        <div class="row cuestionario-area">
          <div class="col-4"></div>
          <div class="col-4 text-center label-black">Pregunta <b>{{PreguntaActual}}</b>/{{Preguntas.length}}</div>
        </div>
        <div id="FilaComentarios" class="row hide">
          <div class="col-12 form-group">
            <h5 class="label-black">Añadir un comentario sobre el evaluado (Máximo 300 caracteres)</h5><br />
            <textarea class="form-control comentarios" type="text" name="" value="" placeholder="Escriba aquí sus comentarios." v-model="comentarios" cols="20" rows="5" maxlength="300"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <button id="BotonTerminar" v-on:click="MostrarComentarios" class="btn btn-custom" v-bind:disabled="ultimaPreguntaRespondida<Preguntas.length">Terminar</button>

            <button id="BotonFinalizarCuestionario" class="btn btn-custom hide" @click="concluirEvaluacion">Concluir Evaluación</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'
  export default {
    props: ['idCuestionario'],
    data() {
      return {
        Preguntas: [

        ]
        , PreguntaActual: 1
        , PreguntasRespondidas: [
        ]
        , ultimaPreguntaRespondida: 0,
        ValorRespuestas: [],
        comentarios: "",
        Cuestionario: null
      }
    },
    components: {
    },
    methods: {
      CargarPreguntas: function () {
        //Carga la información necesaria para hacer la petición
        
        var peticion = {
          "esPrueba": false,
          "CuestionarioId": this.idCuestionario
        };
        comun.SeEstaCargandoInformacion(true);
        return axios.post(api.conexion + api.SISEVA.funcion.GetPreguntasContestadas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(async response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            //console.log(response.data)
            var PreguntasContestadas = response.data.PreguntasContestadas
            this.Cuestionario = response.data.Cuestionario
            this.Preguntas = []
            this.PreguntasRespondidas = []
            var PreguntasAux = []
            var PreguntasRespondidasAux = []
            var ValorRespuestasAux = []
            var Respuestas = []
            var ultimaPreguntaRespondida = this.ultimaPreguntaRespondida
            $.each(PreguntasContestadas, function (indice, PreguntaContestada) {

              Respuestas = [PreguntaContestada.Pregunta.Respuesta1
                , PreguntaContestada.Pregunta.Respuesta2
                , PreguntaContestada.Pregunta.Respuesta3
                , PreguntaContestada.Pregunta.Respuesta4
              ]
              PreguntasAux.push({
                Pregunta: PreguntaContestada.Pregunta.DescripcionPregunta
                , Respuesta1: Respuestas[PreguntaContestada.OrdenRespuestas[0] - 1]
                , Respuesta2: Respuestas[PreguntaContestada.OrdenRespuestas[1] - 1]
                , Respuesta3: Respuestas[PreguntaContestada.OrdenRespuestas[2] - 1]
                , Respuesta4: Respuestas[PreguntaContestada.OrdenRespuestas[3] - 1]
              })
              ValorRespuestasAux.push(PreguntaContestada.OrdenRespuestas)
              PreguntasRespondidasAux.push({
                idPregunta: PreguntaContestada.PreguntaContestadaId
                , idRespuesta: PreguntaContestada.ValorRespuesta
              })
              if (PreguntaContestada.ValorRespuesta != null) {
                ultimaPreguntaRespondida++
              }
            });
            
            this.ultimaPreguntaRespondida = ultimaPreguntaRespondida
            this.Preguntas = PreguntasAux
            this.PreguntasRespondidas = PreguntasRespondidasAux
            this.ValorRespuestas = ValorRespuestasAux
            

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      MostrarComentarios: function () {
        $('.cuestionario-area').hide();
        $('#BotonTerminar').hide();
        $('#FilaComentarios').show();
        $('#BotonFinalizarCuestionario').show();
      },
      PuedeBrincarPreguntas: function (event) {
        let puedeBrincar = false;
        let preguntaActual = this.ObtenerPreguntaActualDelCarrusel();
        let ultimaPreguntaRespondida = this.ultimaPreguntaRespondida;
        let slideDestino = $(event)[0].path[0];
        let valorSlideDestino = $(slideDestino).data('slide-to');
        if (preguntaActual != 0) {
          ((valorSlideDestino <= parseInt(ultimaPreguntaRespondida ))) ? puedeBrincar = true : false;
        }
        else { (this.EstaContestada()) ? puedeBrincar = true : false; }
        return puedeBrincar;
      },
      slideChange(event, index, origenNavegacion) {
        switch (origenNavegacion) {
          case 0: // Origen de navegación "0" = Viene de las flechas
            break;
          case 1: // Origen de navegación "1" = Viene del minimap
            if ( this.PuedeBrincarPreguntas(event)) { //||(!this.EstaContestada() && this.PuedeBrincarPreguntas(event))
              //Obtiene la lista de elementos de la etiqueta enviada
              this.PreguntaActual = index + 1;
            }
            else {
              //console.error('no está contestada o no puede brincar');
              event.stopPropagation();
            }
            break;
          default:
        }
      },
      EstaContestada: function () {
        let respuestaMarcada = $('.carousel-item.active').find('input:checked').length;
        return respuestaMarcada == 1;
      },
      RespuestaSeleccionada: function () {
        return respuestaMarcada = $('.carousel-item.active').find('input:checked');
      },
      CambiarPreguntaAnterior: function (event) {
        if (this.EstaContestada() && this.ObtenerPreguntaActualDelCarrusel() != 0
          || !this.EstaContestada() && this.ObtenerPreguntaActualDelCarrusel() != 0) {
          $('#carruselCuestionario').carousel('prev');
          this.PreguntaActual = this.ObtenerPreguntaActualDelCarrusel() + 1;
        }
      },
      CambiarPreguntaSiguiente: function (event) {
        if (this.EstaContestada()) {
          $('#carruselCuestionario').carousel('next');
          this.PreguntaActual = this.ObtenerPreguntaActualDelCarrusel() + 1;
        }
      },
      IrUltimaPreguntaContestada: function () {
        if (this.ultimaPreguntaRespondida > 0) {
          $('#carruselCuestionario').carousel(this.ultimaPreguntaRespondida - 1);
          this.PreguntaActual = this.ultimaPreguntaRespondida;
        }
      },
      ObtenerPreguntaActualDelCarrusel: function () {
        // Devuelve el número del slide(pregunta) en el que se encuentra el carrusel
        return $('.carousel-indicators').find('li.active').data('slide-to');
      },
      ObtenerNumeroSlideAnterior: function () {
      },
      EsUltimaPreguntaRespondida: function (preguntaActual) {
        let esUltimaPreguntaRespondida = true;
        (preguntaActual > this.ultimaPreguntaRespondida) ? this.ultimaPreguntaRespondida = preguntaActual : esUltimaPreguntaRespondida = false;
        return esUltimaPreguntaRespondida;
      },
      MarcarRespuesta: function (num, index) {
        let valorRespuestaSeleccionada = num;
        let preguntaActual = this.ObtenerPreguntaActualDelCarrusel();
        (preguntaActual > this.ultimaPreguntaRespondida - 1) ? this.ultimaPreguntaRespondida = preguntaActual + 1 : false;
        this.PreguntasRespondidas[preguntaActual].idRespuesta = this.ValorRespuestas[index][valorRespuestaSeleccionada - 1];
        var idPregunta = this.PreguntasRespondidas[preguntaActual].idPregunta;
        var idRespuesta = this.PreguntasRespondidas[preguntaActual].idRespuesta;
        this.guardarPreguntaDB(idPregunta, idRespuesta)
      },
      guardarPreguntaDB: function (idPregunta, idRespuesta) {
        var peticion = {
          "esPrueba": false,
          "idPreguntaContestada": idPregunta,
          "valorRespuesta": idRespuesta
        };
        //comun.SeEstaCargandoInformacion(true);
        return axios.post(api.conexion + api.SISEVA.funcion.GuardarValorRespuesta, peticion).then(async response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      concluirEvaluacion: function () {
        var peticion = {
          "esPrueba": false,
          "idCuestionario": this.idCuestionario,
          "comentarios": this.comentarios
        };
        //comun.SeEstaCargandoInformacion(true);
        return axios.post(api.conexion + api.SISEVA.funcion.FinalizarCuestionario, peticion).then(async response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            comun.mensajeDeAlerta('Has contestado la evaluación exitosamente.\n ¡Muchas gracias!',null,null);
            this.$router.push("/SISEVA/EstatusEvaluadores")
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      idGenerator: function (pregunta, respuesta) {
        return "input-respuesta" + pregunta + "-" + respuesta;
      },
      cargarRespuesta: function (pregunta, respuesta) {
        //console.log(pregunta, respuesta)
        var posicionRespuesta = this.ValorRespuestas[pregunta].indexOf(respuesta) + 1;
        //console.log('input-respuesta' + pregunta + '-' + posicionRespuesta)
        document.getElementById('input-respuesta' + pregunta + '-' + posicionRespuesta).checked = true;
      },
      cargarRespuestas: function () {
        var cargarRespuesta = this.cargarRespuesta
        $.each(this.PreguntasRespondidas, function (index, PreguntaRespondida) {
          if (PreguntaRespondida.idRespuesta != null)
            cargarRespuesta(index, PreguntaRespondida.idRespuesta)
        })
      },
      SeleccionarRespuesta: function (index,num) {
        var id = this.idGenerator(index, num);
        //console.log(id);
        document.getElementById(id).checked = true;
        this.MarcarRespuesta(num, index);
      }
    },
    mounted: async function () {
      //Inhabilita la función automática del carrusel que lo hace girar solo.
      $('.carousel').carousel({
        interval: false
      });
      await this.CargarPreguntas();
      this.cargarRespuestas();
      //this.IrUltimaPreguntaContestada();
      window.addEventListener("keyup", function(e) {
        if (e.keyCode == 39) { console.log('siguiente'); this.CambiarPreguntaSiguiente(e)}
        if (e.keyCode == 37) { console.log('anterior'); this.CambiarPreguntaAnterior(e)}
      }.bind(this));
      
    }
  }
</script>

<style scoped>
  .fa-arrow-alt-circle-left, .fa-arrow-alt-circle-right {
    font-size: 1.3rem;
  }

  .centrado-vertical {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .columna-flecha-navegacion {
    cursor: pointer;
  }

  .comentarios { /* height:70px; */
  }

  .pregunta {
    font-size: 1.7rem;
    font-weight: bold;
    /* margin-bottom: 50px; */
  }

  .respuesta {
    font-size: 1.5rem;
    /* margin-bottom: 25px; */
  }

  .carousel-indicators {
    bottom: -46px;
  }

  textarea {
    height: 130px !important;
  }

  .hide {
    display: none;
  }
  .respuesta span,input{
    cursor: pointer;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
    .arrow-custom {
      color: #004746;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/Evaluacion/Cuestionario.vue